export var isInstanceWithAnchorElement = function isInstanceWithAnchorElement(instance) {
  return Boolean(instance) && Object.prototype.hasOwnProperty.call(instance, 'getAnchorElement');
};